import {AsYouType} from 'libphonenumber-js';

import {startsWith} from 'ramda';

import {dialCodePrefix} from '../constants';

/**
 * @about Returns the national (subscriber) part of a phone number.
 * A number stored together with its dialling code (e.g. `+48501693323`) has the code stripped,
 * a number stored without it is returned unchanged.
 * @param number
 */
export const getNationalNumber = (number: string): string => {
  if (!startsWith(dialCodePrefix, number)) {
    return number;
  }

  const asYouType = new AsYouType();
  asYouType.input(number);

  return asYouType.getNumber()?.nationalNumber.toString() ?? number;
};
